export default __webpack_public_path__ + "static/media/glucerna850.37fb953c.png";